module.exports = __webpack_public_path__ + "img/icon-15.25e13685.png";